<script setup>
import { ref, toRefs, watch } from "vue";
import * as amplitude from "@amplitude/analytics-browser";
import { applicationState } from "../utils/globalReferences";
import Modal from "@/components/Modal.vue";

const props = defineProps({
  visible: Boolean,
  cameras: Array,
  toggle: Function,
  select: Function,
  selectedCamera: String
});

const { visible, cameras } = toRefs(props);
const isVisible = ref(visible);
const items = ref(cameras);

watch(visible, () => {
  isVisible.value = visible.value;
});

watch(cameras, () => {
  items.value = cameras.value;
});
</script>

<template>
<Modal v-if="isVisible" @close="toggle()">
  <template #title>
    {{ $t("retry.sorry") }}
  </template>
  <template #description>
    {{ $t("retry.unable_to_capture") }}
    <br /><br />
    {{ $t("retry.try") }}
  </template>
  <template #footer>
    <div v-for="(item, index) in items">
      <div class="text-center text-lg" :class="[item.deviceId === selectedCamera ? 'text-[#D9D9D9]' : 'text-[var(--secondary)]']" @click="select(index, item.label, true)">
        {{ item.label }}
      </div>
    </div>
  </template>
</Modal>
</template>
